import { createTasks as _createTasks } from '@griply/services';
import { MinimalNewTask, NewTask } from '@griply/types';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  setDoc,
  Timestamp,
  writeBatch,
} from 'firebase/firestore';

import { getAuthentication, getDatabase } from './helpers';

export const createTasks = async (tasks: MinimalNewTask[]) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const db = getDatabase();

  await _createTasks({
    tasks: tasks as unknown as NewTask[],
    userId: user.uid,
    collection,
    doc,
    setDoc,
    db,
    serverTimestamp,
    timestampFromDate: Timestamp.fromDate,
    writeBatch: (_db) => writeBatch(_db as Firestore),
  });
};
